import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'bv-i18n';
import {
  assets_path as assetsPath,
  assets_url as assetsUrl,
} from 'state';

const onError = (e) => {
  if (e.target.src !== assetsPath('/assets/full/icons/darts_avatar@2x.png')) {
    e.target.src = assetsPath('/assets/full/icons/darts_avatar@2x.png');
  }
};

const PlayerImg = ({ imageUrl }) => (
  <img
    className="darts-card__image"
    src={assetsUrl(imageUrl)}
    onError={onError}
    alt="Player Img"
  />
);

PlayerImg.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};

const Player = ({
  playerIndex,
  image_url: imageUrl,
  full_name: fullName,
  outcome,
  three_dart_avg: threeDartAvg,
  percent_doubles_hit: percentDoublesHit,
  last_five_head_to_heads: lastFiveHeadToHeads,
  last_five_results: lastFiveResults,
}) => (
  <li className={`darts-card player${playerIndex}`}>
    <PlayerImg imageUrl={imageUrl} />

    <p className="player-name">
      <span className="label">{ fullName }</span>
      <span className="value">{ outcome }</span>
    </p>
    <p>
      <span className="label">
        { t('javascript.event_extra_information.darts.stats.three_dart_avg') }
      </span>
      <span className="value">{ threeDartAvg }</span>
    </p>
    <p>
      <span className="label">
        { t('javascript.event_extra_information.darts.stats.percent_doubles_hit') }
      </span>
      <span className="value">{ percentDoublesHit }</span>
    </p>
    <p>
      <span className="label">
        { t('javascript.event_extra_information.darts.stats.last_five_head_to_heads') }
      </span>
      <span className="value">{ lastFiveHeadToHeads }</span>
    </p>
    <p>
      <span className="label">
        { t('javascript.event_extra_information.darts.stats.last_five_results') }
      </span>
      <span className="value">{ lastFiveResults }</span>
    </p>
  </li>
);

Player.propTypes = {
  playerIndex: PropTypes.number.isRequired,
  image_url: PropTypes.string.isRequired,
  full_name: PropTypes.string.isRequired,
  outcome: PropTypes.string.isRequired,
  three_dart_avg: PropTypes.string.isRequired,
  percent_doubles_hit: PropTypes.string.isRequired,
  last_five_head_to_heads: PropTypes.string.isRequired,
  last_five_results: PropTypes.string.isRequired,
};

export default Player;
